import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('UI error boundary caught:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          minH="100vh"
          bg="#EFF7FF"
          display="flex"
          alignItems="center"
          justifyContent="center"
          px={6}
        >
          <Alert
            status="error"
            variant="subtle"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            maxW="lg"
            py={8}
            borderRadius="md"
          >
            <AlertIcon boxSize="40px" mr={0} />
            <AlertTitle mt={4} mb={2} fontSize="lg">
              Something went wrong
            </AlertTitle>
            <AlertDescription maxW="sm">
              An unexpected error occurred. You can try again or refresh the page.
            </AlertDescription>
            <VStack mt={6} spacing={3}>
              <Button colorScheme="blue" onClick={this.handleRetry}>
                Try again
              </Button>
              <Button variant="outline" onClick={() => window.location.reload()}>
                Refresh page
              </Button>
            </VStack>
          </Alert>
        </Box>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
